import PayCommissionAllForm from './PayCommissionAllForm';

export default PayCommissionAllForm;
